import React, { createContext, useState } from 'react';

export type LanguageType = 'ja' | 'en';

type LanguageContextType = {
  language: LanguageType;
  setLanguage: React.Dispatch<React.SetStateAction<LanguageType>>;
};

export const LanguageContext = createContext({} as LanguageContextType);

type Props = {
  children: React.ReactNode;
};

// 言語設定を記憶するContext
export const LanguageContextProvider: React.FC<Props> = (props) => {
  const [language, setLanguage] = useState<LanguageType>('ja');

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {props.children}
    </LanguageContext.Provider>
  );
};
